import React, { useEffect, useRef, useState } from "react";

type EditableNameProps = {
    value: string;                 // e.g. resource.name
    isEditing: boolean;            // parent-controlled (toggle when user clicks Rename)
    maxLength?: number;

    className?: string;
    inputClassName?: string;

    onCommit: (nextValue: string) => void; // save rename
    onCancel: () => void;                  // esc/cancel
    onStartEdit?: () => void;              // optional (click name)
};







const RenameTitle: React.FC<EditableNameProps> = ({
    value,
    isEditing,
    maxLength = 40,
    className = "rename-title",
    inputClassName = "",
    onCommit,
    onCancel,
    onStartEdit,
}) => {
    const [draft, setDraft] = useState(value);
    const prevValueRef = useRef(value);
    const inputRef = useRef<HTMLInputElement | null>(null);

    // Keep draft in sync when value changes (e.g. resource updates from server)
    useEffect(() => {
        setDraft(value);
        prevValueRef.current = value;
    }, [value]);

    // Focus/select when editing begins
    useEffect(() => {
        if (isEditing) {
            requestAnimationFrame(() => {
                inputRef.current?.focus();
                inputRef.current?.select();
            });
        }
    }, [isEditing]);

    const commit = () => {
        const next = draft.trim();

        if (!next) {
            setDraft(prevValueRef.current);
            onCancel();
            return;
        }
        if (!next) {
            // if empty, revert and cancel
            setDraft(prevValueRef.current);
            onCancel();
            return;
        }

        if (next.includes(".")) {
            setDraft(prevValueRef.current);
            onCancel();
            return;
        }

        // Only commit if changed
        if (next !== prevValueRef.current) {
            onCommit(next);
            prevValueRef.current = next;
        } else {
            onCancel();
        }
    };




    const isDot = draft.trim().includes(".");
    const isEmpty = !draft;


    const issueMessage = isDot || isEmpty ? 'Enter Valid name' : ''





    const cancel = () => {
        setDraft(prevValueRef.current);
        onCancel();
    };

    return (
        <div className={className}>
            {isEditing ? (
                <div>
                    <input
                        ref={inputRef}
                        value={draft}
                        maxLength={maxLength}
                        className={inputClassName}
                        onChange={(e) => setDraft(e.target.value)}
                        onBlur={commit}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") commit();
                            if (e.key === "Escape") cancel();
                        }}
                    />
                    <span className="rename-issue">{issueMessage}</span>
                </div>
            ) : (
                <p title={value} onClick={onStartEdit}>
                    {value}
                </p>
            )}
        </div>
    );
};

export default RenameTitle;